import React, { memo } from 'react';
import styled from '@emotion/styled';
import { useSelector } from '~Hooks';

interface Props {
  staffId: string;
}

const Wrapper = styled.div`
  position: absolute;
  bottom: 4px;
  left: 4px;
  right: 4px;
  display: flex;
  justify-content: center;
`;

const StaffName = styled.span`
  margin-top: 4px;
  font-size: 10px;
  display: inline-block;
  max-width: 56px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  text-align: center;
`;

const FitStaffName: React.FC<Props> = ({ staffId }) => {
  const companyStaff = useSelector((state) => state.companyStaff);

  const staffName = companyStaff?.staffs?.find((s) => s.id === staffId)?.name || '';

  return (
    <Wrapper>
      <StaffName title={staffName}>{staffName}</StaffName>
    </Wrapper>
  );
};

export default memo(FitStaffName);
